<template lang="pug">
  include ./../../mixins
  div
    //- ui-slider.arrow-appear--onhover.video-slider#slick1(
    //-   :options={
    //-     dots: false,
    //-     infinite: true,
    //-     slidesToShow: 1,
    //-     slidesToScroll: 1,
    //-     arrows: true,
    //-     asNavFor: "#slick2",
    //-     prevArrow: "<div class='video-arrow video-arrow--left mdi mdi-chevron-left' aria-label='Previous'></div>",
    //-     nextArrow: "<div class='video-arrow video-arrow--right mdi mdi-chevron-right' aria-label='Next' style='display: block;'></div>",
    //-   }
    //-   ref="slickSetting1"
    //- )
    //-   template(slot='slide')
    //-     div(v-for='(v, index) in video')
          
    //-       +b.video-big.IFRAME(
    //-         v-if='index == activeV', 
    //-         width="100%"
    //-         height="720" 
    //-         :src="getVideo(v)"
    //-         frameborder="0"
    //-         autoplay='1'
    //-         allowfullscreen
    //-       )
    //-       +b.cursor-pointer.video-slider-img--main.bgi-basic.position_relative(
    //-         @click='showVideo(index)'
    //-         v-else
    //-       )
    //-         +b.img-basic.IMG(:src='getVideoPreview(v)')
    //-         +b.position_absolute.mdi.mdi-play-circle-outline.color_white.play-button.z-index_10
    //-         +b.mask.position_absolute


    ui-slider.video-slider.arrow-appear--onload.margin_top_sm(
      :options={
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: "<div class='video-arrow video-arrow--left video-arrow--white mdi mdi-chevron-left' aria-label='Previous'></div>",
        nextArrow: "<div class='video-arrow video-arrow--right video-arrow--white mdi mdi-chevron-right' aria-label='Next' style='display: block;'></div>",
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 1,
            }
          },
          
        ]
      }
      ref="slickSetting2"
    )

      template(slot='slide')
        +b.video-slider-img--preview.bgi-basic.cursor-pointer(v-for='(v, index) in video')
          +b.img-basic.IMG(:src='getVideoPreview(v)')
          +b.position_absolute.mdi.mdi-play-circle-outline.color_white.play-button.z-index_10(@click='showModal(index)')
          +b.mask.position_absolute
</template>
<script>
import VideoModal from "../Modal/VideoModal.vue"
export default {
  props: {
    video: {
      type: Array
    }
  },

    
  
  data() {
    return {
      activeV: null
    }
  },

  methods: {
    showModal(index) {
      if (this.video) {
        this.$modal.show(VideoModal, {
          src: this.video[index]
        }, {
          classes: "modal modal--video",
          name: "video"
        })
      }
    },
    getVideoId(url) {
      // console.log(url)
      let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
      let match = url.match(regExp)
      let eleven = 11
      if (match && match[2].length == eleven) {
        return match[2]
      }
      return 'error'
    },

    getVideoPreview(url) {
      let videoPreview = `//img.youtube.com/vi/${this.getVideoId(url)}/0.jpg`
      return videoPreview
    },

    getVideo(el) {

      let item = `//www.youtube.com/embed/${this.getVideoId(el)}?autoplay=1`
      return item
      
    },

    showVideo(i) {
      this.activeV = i
    }   
  } 
}
</script>


// WEBPACK FOOTER //
// src/js/components/VideoSlider/VideoSlider.vue